// src/pages/HerstellerEditPage.jsx
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import HerstellerForm from "../components/hersteller/HerstellerForm";
import axios from "axios";

export default function HerstellerEditPage() {
    const { id } = useParams();
    const [hersteller, setHersteller] = useState(null);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/api/hersteller/${id}`)
            .then((res) => {
                const data = res.data;
                const typen = [];
                if (data.wechselrichter) typen.push("wechselrichter");
                if (data.energiespeicher) typen.push("energiespeicher");
                if (data.datenlogger) typen.push("datenlogger");
                if (data.modul) typen.push("modul");

                setHersteller({ ...data, typen });
            })
            .catch((err) => console.error("Fehler beim Laden des Herstellers:", err));
    }, [id]);

    if (!hersteller) return <p>Lade Herstellerdaten...</p>;

    return <HerstellerForm existingHersteller={hersteller} />;
}